// Create a Set for O(1) lookup performance
export const NUMERIC_COLUMNS = new Set([
  "qty",
  "quantity",
  "price",
  "minQty",
  "maxQty",
  "ytm",
  "ytw1",
  "accruedInterest",
  "estimatedTotal",
  "duration",
  "executedQuantity",
  "executedAveragePrice",
  "numberOfRungs",
  "amountPerRung",
  "totalMaturity",
  "altMinTax",
  "insured",
  "ytc",
  "orderExpiryDtTime",
  "ttl",
  "coupon",
  "poolFactor",
  "securityMarketValue",
  "totalGL",
  "realizedGL",
  "unrealizedGL",
  "yield",
  "yieldToWorst",
  "yieldValuePp",
  "dollarConvexity",
  "dv01",
  "accruedInterest",
  "macaulayDuration",
  "callPrice",
  "accuredInterest",
  "modifiedConvexity",
  "endingPrice",
  "tradingPrice",
  "currentPrice",
  "endingQuantity",
  "currentQuantity",
  "tradeQuantity",
  "tradePrice",
  "currentYield",
  "currentDuration",
  "currentDv01",
  "currentRatingSnp",
  "currentRatingMoody",
  "endingYield",
  "endingDuration",
  "endingDv01",
  "endingRatingSnp",
  "endingRatingMoody",
  "couponPer",
  "endingSecurityMarketValue",
  "tradeValue",
  "ttl",
  "quoteSubmissionDeadline",
  "mktxTargetLevel",
  "bidQuantity",
  "bidPrice",
  "bidYield",
  "offerQuantity",
  "offerPrice",
  "offerYield",
  "securityWeightPercentage",
  "endingSecurityWeightPercentage",
  "id",
  "totalRecords",
  "updatedRecords",
  "insertedRecords",
  "failedRecords",
  "histUpdatedRecords",
  "histInsertedRecords",
  "isActive",
  // NOTE: "actions" is deliberately excluded - it's a render column
]);

// New: columns that need higher precision (5 decimals)
export const HIGH_PRECISION_NUMERIC = new Set([
  "yield",
  "yieldToWorst",
  "currentYield",
  "endingYield",
  // NOTE: Live market-data "bidYield"/"offerYield" are deliberately NOT here — the
  // MA Inventory table renders them at the default 2 decimals (the filter also
  // compares them at 2; see MA_INVENTORY_FILTER_COMPARE_DECIMALS in maInventoryStore).
  "yieldValuePp",
  "duration",
  "dollarDuration",
  "dv01",
  "modifiedConvexity",
  // securityWeightPercentage removed here so it renders with the default 2 decimals
]);
